import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

import { LucbanGenesisLogo } from 'images';

export const exportToExcel = async (data, columns, fileName = 'report.xlsx', sheetName = 'Transactions') => {
  // Create workbook and worksheet
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(sheetName);

  const logoBase64 = await getImageBase64(LucbanGenesisLogo);
  const base64Data = logoBase64.split(',')[1];
  const imageBuffer = Buffer.from(base64Data, 'base64');
  const imageId = workbook.addImage({
    buffer: imageBuffer,
    extension: 'png'
  });

  worksheet.addImage(imageId, {
    tl: { col: columns.length / 2 - 2, row: 0 },
    ext: { width: 150, height: 120 }
  });

  // Multi-line header text lines
  const headerLines = [
    'LUCBAN GENESIS TRANSPORT SERVICE & MPC',
    'CDA Registration No. 9520-04009811',
    'OTC Accreditation No. 2011-265',
    'Contact No. (042) 719-2468'
  ];

  headerLines.forEach((text, i) => {
    const row = worksheet.getRow(i + 1);
    row.values = [text];
    row.height = 18;
    worksheet.mergeCells(`A${i + 1}:${String.fromCharCode(65 + columns.length - 1)}${i + 1}`);
    row.alignment = { vertical: 'middle', horizontal: 'center' };
    row.font = { bold: true, size: 12 };
  });

  const headerStartRow = headerLines.length + 4;
  // Set column headers
  const headerRow = worksheet.getRow(headerStartRow);
  headerRow.values = columns.map((col) => col.text);
  headerRow.font = { bold: true };

  headerRow.eachCell((cell) => {
    cell.border = {
      top: { style: 'thin' },
      bottom: { style: 'thin' },
      left: { style: 'thin' },
      right: { style: 'thin' }
    };
    cell.alignment = { vertical: 'middle', horizontal: 'left' };
  });

  // Add data starting next row
  data.forEach((mapItem, index) => {
    const rowData = columns.map((col) => {
      const val = mapItem.get(col.key);
      return typeof val === 'string' ? val : val?.props?.children || '';
    });

    const row = worksheet.getRow(headerStartRow + 1 + index);
    row.values = rowData;

    const isBold = mapItem.get('isParent') || mapItem.get('isTotal');
    row.font = isBold ? { bold: true } : {};

    row.eachCell((cell) => {
      cell.border = {
        top: { style: 'thin' },
        bottom: { style: 'thin' },
        left: { style: 'thin' },
        right: { style: 'thin' }
      };
      cell.alignment = { vertical: 'middle', horizontal: 'left' };
    });
  });

  // Optional: set column widths (adjust as needed)
  worksheet.columns.forEach((col) => {
    col.width = 20;
  });

  // Write workbook to buffer and save
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  saveAs(blob, fileName);
};

export const getImageBase64 = async (imageUrl) => {
  const response = await fetch(imageUrl);
  const blob = await response.blob();

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};
